import { emojiDefaults } from "@/components/emoji/emoji.type.ts";
import { resolveEmojiUnifiedId } from "@/components/emoji/emoji-datasource.ts";
import emojiColors from "@/components/emoji/emoji_colors.json";

interface EmojiColorsMap {
  [key: string]: string[];
}

const emojiColorMap = emojiColors as EmojiColorsMap;

export const getEmojiColorPalette = (emoji: string): string[] => {
  if (!emoji) {
    return [];
  }

  const unifiedId = resolveEmojiUnifiedId(emoji);
  return unifiedId ? emojiColorMap[unifiedId] || [] : [];
};

export const getRandomDefaultEmoji = (entityEmojis: Record<string, string>): string => {
  const emojiOptions = Object.values(entityEmojis).filter(
    (emoji) => emoji !== entityEmojis.default
  );

  if (emojiOptions.length === 0) {
    return entityEmojis.default || emojiDefaults.default;
  }

  return emojiOptions[Math.floor(Math.random() * emojiOptions.length)];
};
